import API from './index';

const api = {
    getNotifications({ page = 1, pageSize = 20}) {
        return API.authAPI({
            url: '/notification/get-notifications',
            method: 'GET',
            params: {
                page,
                pageSize
            },
        });
    },
    getNotificationsCountOfUnread() {
        return API.authAPI({
            url: '/notification/get-count-of-unread',
            method: 'GET',
        });
    },
    postNotificationMarkRead({ id, markAll }) {
        return API.authAPI({
            url: '/notification/mark-read',
            method: 'POST',
            data: {
                id,
                markAll
            },
        });
    },
};

export default api;
